import { ClaimAction } from "./types";

export const submitClaim = (payload) =>
  ({
    type: ClaimAction.SUBMIT_CLAIM,
    payload,
  } as const);

export const cleanUpClaimInfo = () =>
  ({
    type: ClaimAction.CLEAN_UP,
  } as const);

export const uploadInvoiceRequest = (file: File) =>
  ({
    type: ClaimAction.UPLOAD_INVOICE_REQUEST,
    payload: file,
  } as const);

export const uploadInvoiceSuccess = (payload: { url: string; key?: string }) =>
  ({
    type: ClaimAction.UPLOAD_INVOICE_SUCCESS,
    payload,
  } as const);

export const uploadInvoiceFailure = (error: string) =>
  ({
    type: ClaimAction.UPLOAD_INVOICE_FAILURE,
    payload: error,
  } as const);

export const restoreClaimData = (payload: any) =>
  ({
    type: ClaimAction.RESTORE_CLAIM_DATA,
    payload,
  } as const);
